import React from "react";
import {
  AddIcon
} from "../../assets/icons/icons";
import { Link } from "react-router-dom";
import dashboardMainPages from "../data/dashboardMainPages";
export default function Dashboard() {
  const showData = dashboardMainPages.map((el, index) =>
    <Link key={index} to={el.url} className="flex justify-center items-center w-[250px] relative h-[85px] rounded-[10px] capitalize bg-gradient-to-r from-[#1485a6] to-[#4d759e] text-white">
      <div className="absolute top-[-45%] bg-[#1485a6] w-[50px] h-[50px] rounded-full flex items-center justify-center"><AddIcon /></div>
      <div>{el.title}</div>
    </Link>
  )
  return (
    <section className="py-[25px] flex flex-col gap-[50px]">
      <div className="container">
        <div className="main-title">Main options</div>
        <div className="flex justify-center flex-wrap gap-y-[50px] gap-x-[20px] py-[70px]">
          {showData}
        </div>
      </div>
    </section>
  );
}